import React from 'react'
import { Avatar as AntdAvatar } from 'antd'
import { getContrastColor } from '../../../utils/colors.helper'
import { primaryColor } from '../../../constants/styles'
import { getNameInitials } from '../../../utils/text.helper'
import { UserOutlined } from '@ant-design/icons'

const getSizePixels = (size) => {
    if (typeof size === 'number') return size
    
    switch (size) {
        case 'large': return 40
        case 'small': return 24
        case 'default':
        default: return 32
    }
}

const Avatar = ({ name, icon: customIcon, color = primaryColor, size = 'default', ...rest }) => {
    const pixelSize = getSizePixels(size)
    
    return (
        <AntdAvatar
            size={size}
            style={{
                backgroundColor: color,
                color: getContrastColor(color),
                minWidth: `${pixelSize}px`,
                minHeight: `${pixelSize}px`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                flexShrink: 0
            }}
            icon={customIcon || (!name && <UserOutlined />)}
            {...rest}
        >
            {getNameInitials(name)}
        </AntdAvatar>
    )
}

export default Avatar
